import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

const baseURL = process.env.REACT_APP_BASE_BACKEND_API_URL;

export const createOrganization = async (orgName, logoUrl, reportEmails = []) => {
  const accessToken = Cookies.get("accessToken");
  try {
    const response = await axios.post(
      `${baseURL}api/v1/organization/create`,
      { organizationName: orgName, logo: logoUrl, reportEmails: Array.isArray(reportEmails) ? reportEmails : [] },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating organization:", error);
    throw error;
  }
};

export const fetchOrganizations = async (accessToken) => {
  try {
    const response = await axios.get(
      `${baseURL}api/v1/organization/get-list`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );
    if (!response || !response.data || response.data.header.code !== 600) {
      throw new Error("Failed to fetch organizations");
    }
    return response.data.body.value;
  } catch (error) {
    console.error("Error fetching organizations:", error);
    throw error;
  }
};

/**
 * Update user profile.
 * PUT api/v1/user/update-profile
 * Payload: same as create (name, email, phone, userType, areaCode, userStatus, organization, departmentList, projectList, workflowList, roleIds) + userId
 */
export const updateUser = async (userData, token) => {
  try {
    const response = await axios.put(
      `${baseURL}api/v1/user/update-profile`,
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error;
  }
};

export const updateProfileInfo = async (userId, name, email, phone, password, isPasswordCleared,) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.post(
      `${baseURL}api/v1/user/update-profile`,
      {
        userId,
        name,
        email,
        phone,
        password,
        passwordChanged: isPasswordCleared
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
};
//get userinfo
export const getUserInfo = async () => {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.get(
      `${baseURL}api/v1/user/user-detail`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.body.value;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
};

//upload profile picture
export const updateProfilePicture = async (url) => {
  console.log(url)
  const token = Cookies.get("accessToken");

  try {
    const userId = Cookies.get("userId");
    const response = await axios.post(
      `${baseURL}api/v1/user/profile-pic`,
      {
        userId,
        profilePic: url,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    let profilePic = Cookies.get("profilePic");

    if (profilePic) {
      Cookies.remove("profilePic");
    }

    Cookies.set("profilePic", url);
    return response.data;
  } catch (error) {
    console.error(
      "Error updating profile picture:",
      error.response ? error.response.data : error
    );
    throw error;
  }
};

//get list of orgnization
export const fetchOrgnizationData = async (currentPage, pageSize) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.get(
      `${baseURL}api/v1/organization/list/get-all?page=${currentPage}&size=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

//get org info by id
export const fetchOrganizationById = async (orgnizationId) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.get(
      `${baseURL}api/v1/organization/get?id=${orgnizationId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching organization data:", error);
    throw error;
  }
};
//update org
export const UpdateOrganizationData = async (
  editOrganizationname,
  newLogoUrl,
  orgnizationId,
  reportEmails = []
) => {
  const accessToken = Cookies.get("accessToken");
  try {
    const response = await axios.post(
      `${baseURL}api/v1/organization/create`,
      {
        organizationId: orgnizationId,
        organizationName: editOrganizationname,
        logo: newLogoUrl,
        reportEmails: Array.isArray(reportEmails) ? reportEmails : [],
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error creating organization:", error);
    throw error;
  }
};


// get all organization list 
export const getAllByOrganization = async () => {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.get(
      `${baseURL}api/v1/organization/get-list`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.body.value;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
};

// get all organization list by id
export const getAllByOrganizationId = async (organizationId) => {
  const token = Cookies.get("accessToken");

  if (!organizationId) {
    throw new Error("organization is mandatory");
  }
  const cleanId = String(organizationId).replace(/"/g, "");

  try {
    const response = await axios.get(
      `${baseURL}api/v1/department/get-all?organizationId=${cleanId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.body.value;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
};

// get project list by department id
export const getProjectListByDepartmentId = async (departmentId) => {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.get(
      `${baseURL}api/v1/project/get-all-by-departments?departmentIds=${departmentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.body.value;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
};

// get workflow field values (returns fieldKeyOptions + valueOptions + rawFields for per-field values)
export const getWorkflowFieldValues = async (workflowId) => {
  const token = Cookies.get("accessToken");
  if (!workflowId) return { fieldKeyOptions: [], valueOptions: [], rawFields: [] };
  try {
    const response = await axios.get(
      `${baseURL}api/v1/workflow/get-workflow-field-values`,
      {
        params: { workflowId },
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (response.data?.header?.code !== 600 || !response.data?.body?.value) {
      return { fieldKeyOptions: [], valueOptions: [], rawFields: [] };
    }
    const list = Array.isArray(response.data.body.value) ? response.data.body.value : [];
    const rawFields = list.map((item) => ({
      fieldName: item.fieldName,
      uniqueKey: item.uniqueKey,
      values: Array.isArray(item.values) ? item.values.map((v) => String(v).trim()).filter(Boolean) : [],
    }));
    const fieldKeyOptions = rawFields.map((item) => ({
      value: item.uniqueKey,
      label: item.fieldName || item.uniqueKey || "",
    })).filter((o) => o.value);
    const valuesSet = new Set();
    rawFields.forEach((item) => item.values.forEach((v) => valuesSet.add(v)));
    const valueOptions = Array.from(valuesSet).map((v) => ({ value: v, label: v }));
    return { fieldKeyOptions, valueOptions, rawFields };
  } catch (err) {
    console.error("Error fetching workflow field values:", err);
    return { fieldKeyOptions: [], valueOptions: [], rawFields: [] };
  }
};

// get activity list by project id
export const getActivityListByProjectId = async (projectId) => {
  const token = Cookies.get("accessToken");
  if (!projectId) {
    throw new Error("Project ID is mandatory");
  }
  try {
    const response = await axios.get(
      `${baseURL}api/v1/workflow/get-activities?projectId=${projectId}`, // update end point by harshit 23-12-2025
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.body.value;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
};

// create deparment
export const getDeparment = async (payload) => {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.post(
      `${baseURL}api/v1/department/create`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.data.header.code === 600) {
      toast.success(response.data.body.value)
    }
    else {
      toast.error(response.data.body.value)
    }
    return response.data.body;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
};

// update department (same API as create; payload: { id, organizationId, name })
export const updateDepartment = async (payload) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.post(
      `${baseURL}api/v1/department/create`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.data.header.code === 600) {
      toast.success(response.data.body.value);
    } else {
      toast.error(response.data.body.value);
    }
    return response.data;
  } catch (error) {
    console.error("Error updating department:", error);
    throw error;
  }
};

// create project
export const getProject = async (payload) => {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.post(
      `${baseURL}api/v1/project/create`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.data.header.code === 600) {
      toast.success(response.data.body.value)
    }
    else {
      toast.error(response.data.body.value)
    }
    return response.data.body.value;

  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
};


// update project
export const updateProject = async (projectId, payload) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.post(
      `${baseURL}api/v1/project/update`,
      { projectId, ...payload },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    if (response.data?.header?.code === 600) {
      toast.success(response.data?.body?.value ?? "Project updated");
    } else {
      toast.error(response.data?.body?.value ?? "Failed to update project");
    }
    return response.data;
  } catch (error) {
    console.error("Error updating project:", error);
    throw error;
  }
};

// get project by id (full details including DCRC config)
export const getProjectById = async (projectId) => {
  const token = Cookies.get("accessToken");
  if (!projectId) return null;
  try {
    const response = await axios.get(
      `${baseURL}api/v1/project/get`,
      {
        params: { projectId },
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (response.data?.header?.code === 600 && response.data?.body?.value) {
      const value = response.data.body.value;
      return Array.isArray(value) ? value[0] : value;
    }
    return null;
  } catch (err) {
    console.error("Error fetching project by id:", err);
    return null;
  }
};

// all project 

export const getProjectList = async (departmentId) => {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.get(
      `${baseURL}api/v1/project/get-all?departmentId=${departmentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.body.value;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
};


// get multiple project 


export const getMultipleProject = async (departmentId) => {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.get(
      `${baseURL}api/v1/project/get-all-by-departments?departmentIds=${departmentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.body.value;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
};

// get multiple Activity (by multiple project IDs)
export const getMultipleActivity = async (projectIds) => {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.get(
      `${baseURL}api/v1/workflow/get-workflow-list-by-projects?projectIds=${projectIds}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.body.value;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
};

// get workflow list by single project ID (for activity dropdown)
export const getWorkflowListByProjectId = async (projectId) => {
  const token = Cookies.get("accessToken");
  if (!projectId) return [];
  try {
    const response = await axios.get(
      `${baseURL}api/v1/workflow/get-workflow-list?projectId=${projectId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const value = response.data?.body?.value;
    return Array.isArray(value) ? value : [];
  } catch (error) {
    console.error("Error fetching workflow list by project:", error);
    throw error;
  }
};

// update project status (DCRC enable/disable)
export const updateProjectStatus = async (projectId, isDcrcEnabled) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.post(
      `${baseURL}api/v1/project/update-status`,
      { projectId, isDcrcEnabled },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    if (response.data?.header?.code === 600) {
      return response.data;
    }
    throw new Error(response.data?.body?.value || "Failed to update project status");
  } catch (error) {
    console.error("Error updating project status:", error);
    throw error;
  }
};

// update project delete status (soft delete)
export const updateProjectDeleteStatus = async (projectId, isDeleted) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.post(
      `${baseURL}api/v1/project/update-delete-status`,
      { projectId, isDeleted },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    if (response.data?.header?.code === 600) {
      return response.data;
    }
    throw new Error(response.data?.body?.value || "Failed to update project delete status");
  } catch (error) {
    console.error("Error updating project delete status:", error);
    throw error;
  }
};

// projects-for-clock-in

export const projectsForClockIn = async (projectIds) => {
  const token = Cookies.get('accessToken');
  try {
    const response = await axios.get(`${baseURL}api/v1/project/get/projects-for-clock-in?projectIds=${projectIds}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response || !response.data || !response.data.header || response.data.header.code !== 600) {
      throw new Error('Failed to fetch user details');
    }

    return response.data.body.value;
  } catch (error) {
    console.error('Error fetching user details:', error);
    throw error;
  }
};